import { createAction } from '@reduxjs/toolkit'

import { REFRESH_ACTION_REQUEST } from '../config'

export const refreshActionRequest = createAction(REFRESH_ACTION_REQUEST, () => {
  return { payload: null }
})
